import { ScreenSharingRequestMessage } from '@/services/ScreenSharing/ScreenSharingRequestMessage';

export interface PingMessage {
	type: 'ping';
}

export const pingMessage = (): PingMessage => ({ type: 'ping' });

export enum DocumentStatusMessageType {
	credentialReport = 'broadcast',

	policyDocument = 'docstatus',

	// Intentionally the same as above.
	lossReport = 'broadcast',
}

export interface DocumentStatusMessage {
	document_id: string;
	fname?: string;
	msg: string;
	ready: boolean;
	type: DocumentStatusMessageType;
}

export type Message = DocumentStatusMessage | PingMessage | ScreenSharingRequestMessage;
